import { render } from "./formItem.vue?vue&type=template&id=3ddb3efa&ts=true"
import script from "./formItem.vue?vue&type=script&lang=ts"
export * from "./formItem.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\equistasi\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__